import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateEmail } from "@qgiv/core-validation";
import {
    selectAcceptedEmailReminders,
    setAcceptEmailRemindersData,
} from "../../../redux/slices/abandonedGiftSlice";
import { selectPreventRefreshOnClose } from "../../../redux/slices/urlShortcutsSlice";
import { sendPostMessage } from "../../PostMessage/postMessage";
import EmailReminderExitIntent from "./EmailReminderExitIntent";

const ConnectedEmailReminderExitIntent = () => {
    const [emailAddress, setEmailAddress] = useState("");
    const [displayLoadingAnimation, setDisplayLoadingAnimation] =
        useState(false);
    const dispatch = useDispatch();
    const [error, setError] = useState(false);

    const preventRefreshOnClose = useSelector(selectPreventRefreshOnClose);
    const acceptedEmailReminders = useSelector(selectAcceptedEmailReminders);

    const handleChange = (e) => {
        const { target } = e;
        const { value } = target;
        setEmailAddress(value);
        // clear existing error is valid email
        const isValidEmail = validateEmail(value);
        if (error && isValidEmail) {
            setError(false);
        }
    };

    const handleBlur = (e) => {
        const { target } = e;
        const { value } = target;
        const isValidEmail = validateEmail(value);
        const isErroredEmail = !isValidEmail;
        setError(isErroredEmail);
    };

    const handleAcceptReminderClick = () => {
        const isValidEmail = validateEmail(emailAddress);
        if (isValidEmail) {
            dispatch(
                setAcceptEmailRemindersData({
                    acceptedEmailReminders: true,
                    emailForReminders: emailAddress,
                }),
            );
            return;
        }
        setError(true);
    };

    // Don't want to have the regular button display before
    // the modal closes after clicking accept
    useEffect(() => {
        if (acceptedEmailReminders) {
            setDisplayLoadingAnimation(true);
        }
    }, [acceptedEmailReminders, setDisplayLoadingAnimation]);

    const handleDeclineReminderClick = () => {
        sendPostMessage("closeFullScreenModal", preventRefreshOnClose);
    };

    return (
        <EmailReminderExitIntent
            displayLoadingAnimation={displayLoadingAnimation}
            emailAddress={emailAddress}
            error={error}
            errorText="Please enter a valid email address."
            handleAcceptReminderClick={handleAcceptReminderClick}
            handleBlur={handleBlur}
            handleChange={handleChange}
            handleDeclineReminderClick={handleDeclineReminderClick}
        />
    );
};

export default ConnectedEmailReminderExitIntent;
